import api from 'services/api';

const archiveTodoEmailService = async (todoID: string) => {
  await api.todo.archive(todoID);
};

export default archiveTodoEmailService;
